<template lang="pug">
.player-wrap(:id='finalConfig.id')
</template>

<script>
import { mergeDeep, percentage } from '@/util/index'
import { mapGetters } from 'vuex'

const defaultBuryCfg = {
  lastWaiting: null, //最近一次开始卡顿的时间戳
  isFullScreen: null, //当前是否为全屏
  bury90: false, //本集是否上报过播放90的事件
  buryEnded: false, //本集是否上报过播放完成事件
  timeUpdate: false, //-false首帧 -true 非首帧
  endInfo: {
    duration: null, //播放时长
    videoDuration: null, //视频时长
    responseTime: null, //播放器开始加载时间戳
    firstFrameTime: null, //首帧时间戳
    playEndTime: null, //结束时间戳
    startFrame: null, //起始播放帧
    lang: null, //字幕
    playSpeed: null //倍速
  }
}

export default {
  name: 'XgPlayer',
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      // 事件列表 https://v2.h5player.bytedance.com/api/#%E4%BA%8B%E4%BB%B6
      playerEventList: [
        'play',
        'playing',
        'pause',
        'ended',
        'error',
        'seeking',
        'seeked',
        'waiting',
        'canplay',
        'canplaythrough',
        'durationchange',
        'requestFullscreen',
        'exitFullscreen',
        'playbackrateChange',
        'timeupdate',
        'replay'
      ],
      playerEventListCustom: ['definitionChange', 'openEpisode', 'switchSubTitle', 'onPlayNextBtnClick'],
      player: null,
      exposure: null,
      initConfig: {
        id: 'mse',
        url: '',
        fluid: true,
        lang: this.$i18n.locale,
        // lang: 'zh_CN',
        volume: 0.5,
        width: 860,
        height: 538,
        videoInit: true,
        playsinline: true,
        // 设置播放速度
        playbackRate: [0.5, 0.75, 1.0, 1.5, 2, 3],
        ignores: ['playNext'],
        // ignores: ['loading', 'playbackRate', 'textTrack', 'playNext', 'time', 'definition', 'error', 'fullscreen', 'i18n', 'loading', 'mobile', 'pc', 'play', 'progress', 'replay', 'volume'],
        preloadTime: 25,
        defaultPlaybackRate: 1.0,
        // 画中画
        // pip: true,
        keyShortcut: 'on',
        airplay: false,
        definitionActive: 'hover',
        textTrackActive: 'hover',
        // 如果自定义插件，想通过播放器初始化的时候传递配置参数进来，可以直接定义。
        customConfig: {
          // 是否有下一级；用来判断展示下一级按钮
          hasPlayNext: false,
          // 清晰度切换空间
          definitionList: [],
          // 全屏情况下是否有集按钮
          hasEpisode: false
        }
      },
      buryCfg: {
        ...defaultBuryCfg
      },
      hadEnded: null,
      startClickPlay: null
    }
  },
  computed: {
    ...mapGetters(['changeEpisodeHistory', 'isClickPlay', 'newSeries']),
    finalConfig() {
      return mergeDeep(this.initConfig, this.config)
    }
  },
  watch: {
    // 'config.resourceReady': {
    //   handler(val) {
    //     console.log('ssssss')
    //     this.player.emit('resourceReady', val)
    //   },
    //   deep: true
    // },
    config: {
      handler(val) {
        console.log('config changed', val)
        this.init()
      },
      deep: true
    }
  },
  mounted() {
    console.log('--------------mounted-------------:', process.client)
    // this.init()
    // setTimeout(() => {
    //   this.watchPosition()
    // }, 1000)
  },
  beforeUpdate() {
    if (!process.client) return
    console.log('--------------beforeUpdate-------------:', process.client)
  },
  beforeDestroy() {
    if (!process.client) return
    if (!this.buryCfg.buryEnded) {
      // 未上报过videoPlay事件就更换播放内容 手动上报
      this.buryCfg.endInfo.playEndTime = new Date().getTime()
      this.$emit('onPlayBury', 'videoPlay', {
        autoPlay: this.hadEnded || this.startClickPlay ? '手动点击' : '自动播放',
        fullScreen: this.buryCfg.isFullScreen ? '是' : '否',
        rate: `${percentage(this.buryCfg.endInfo.duration || 0, this.buryCfg.endInfo.videoDuration || 0)}%`,
        ...this.buryCfg.endInfo
      })
      if (!this.newSeries) {
        // 添加当前播放记录
        this.$store.commit('play/SET_EPISODEHISTORY', this.config)
      } else {
        // 若因为切换新的剧集而销毁当前播放器 清除上一部剧集的播放记录
        this.$store.commit('play/CLEAN_EPISODEHISTORY')
      }
    }
    this.player && typeof this.player.destroy === 'function' && this.player.destroy()
    this.exposure && this.exposure.disconnect()
    this.$store.commit('play/SET_NEWSERIES', false) //当前播放器销毁时重置 下次如果为新剧 取最新的
  },
  methods: {
    resetBuryCfg() {
      this.buryCfg = { ...defaultBuryCfg }
    },
    init() {
      // require('xgplayer')
      const HlsJsPlayer = require('xgplayer-hls.js')
      require('./xgplayer-style/skin/index1.js')
      console.log('--------------init-------------:', process.client)
      if (this.player) {
        this.player.destroy()
      }
      this.resetBuryCfg()
      this.player = new HlsJsPlayer(this.finalConfig)
      this.startClickPlay = this.isClickPlay
      this.buryCfg.endInfo.responseTime = new Date().getTime()
      this.$emit('player', this.player)
      this.player.emit('resourceReady', this.finalConfig.customConfig.definitionList)
      this.eventRegistry()
      // 移除多余的controls
      const controls = document.querySelectorAll('.xgplayer-controls')
      for (let i = 1; i < controls.length; i++) {
        controls[i].remove()
      }
      // 重新初始化时候，有时候会出现两个video标签，社区也有人反馈，，没找到问题
      const v = document.querySelectorAll('video')
      for (let i = 1; i < v.length; i++) {
        v[i].remove()
      }
    },
    eventRegistry() {
      // 监听事件
      this.playerEventList.concat(this.playerEventListCustom).forEach((eventName) => {
        this.player.on(eventName, (arg, ...args) => {
          console.log('player事件：', eventName, arg, args)
          this.eventBury(eventName, arg)
          this.$emit(eventName, arg, ...args)
        })
      })
    },
    watchPosition() {
      // if (!this.finalConfig.url) return
      this.exposure = new IntersectionObserver(
        (entries) => {
          if (this.player.paused) return
          if (entries[0].intersectionRatio <= 0) {
            this.player.getMiniplayer()
          } else {
            this.player.exitMiniplayer()
          }
        },
        { threshold: [0] }
      )
      this.exposure.observe(document.getElementById(this.finalConfig.id).parentElement)
    },
    eventBury(eventName, item) {
      switch (eventName) {
        case 'requestFullscreen':
          this.buryCfg.isFullScreen = true
          this.$emit('onBury', '进入全屏', '全屏')
          break
        case 'exitFullscreen':
          this.buryCfg.isFullScreen = false
          this.$emit('onBury', '退出全屏', '全屏')
          break
        case 'switchSubTitle':
          this.buryCfg.endInfo.lang = item.id
          this.$emit('onBury', item.id, '字幕')
          break
        case 'playbackrateChange':
          this.buryCfg.endInfo.playSpeed = Number(item.to) === 1 ? '1.0' : item.to
          this.$emit('onBury', item.to, '倍数')
          break
        case 'definitionChange':
          this.$emit('onBury', item.to, '清晰度切换')
          break
        case 'play':
          this.buryCfg.endInfo.continuous = this.changeEpisodeHistory.length ? `连续${this.changeEpisodeHistory.length + 1}集` : '连续1集'
          this.buryCfg.endInfo.playSpeed = Number(item.video.defaultPlaybackRate) === 1 ? '1.0' : item.video.defaultPlaybackRate
          this.buryCfg.endInfo.lang = item.config.lang
          this.buryCfg.endInfo.videoDuration = item.video.duration
          this.$emit('onPlayBury', 'playClick', { autoPlay: this.hadEnded || this.isClickPlay ? '手动点击' : '自动播放', ...this.buryCfg.endInfo })
          if (this.hadEnded) {
            this.$emit('onPlayBury', 'playProcess', { stage: 0, autoPlay: this.hadEnded || this.isClickPlay ? '手动点击' : '自动播放', ...this.buryCfg.endInfo })
          }
          if (this.buryCfg.buryEnded) {
            this.resetBuryCfg()
          }
          break
        case 'timeupdate':
          // 首次播放时长发生变化
          if (!this.buryCfg.timeUpdate) {
            this.buryCfg.endInfo.firstFrameTime = new Date().getTime()
            this.buryCfg.endInfo.startFrame = item.video.currentTime
            this.$emit('onPlayBury', 'playProcess', { stage: 4, autoPlay: this.hadEnded || this.isClickPlay ? '手动点击' : '自动播放', ...this.buryCfg.endInfo })
          }
          this.buryCfg.endInfo.duration = item.video.currentTime
          this.buryCfg.timeUpdate = true
          // 播放时长超过90%
          if (percentage(item.video?.currentTime || 0, item.video?.duration || 0) >= 90 && !this.buryCfg.bury90) {
            this.$emit('onPlayBury', 'playProcess', { stage: 7, autoPlay: this.hadEnded || this.isClickPlay ? '手动点击' : '自动播放', ...this.buryCfg.endInfo })
            this.buryCfg.bury90 = true
          }
          break
        // case 'pause':
        //   this.hadEnded = new Date().getTime()
        //   break
        case 'ended':
          this.$store.commit('play/SET_EPISODEHISTORY', this.config)
          this.buryCfg.endInfo.playEndTime = new Date().getTime()
          // this.$emit('onPlayBury', 'playProcess', { stage: 6 })
          this.$emit('onPlayBury', 'videoPlay', {
            fullScreen: this.buryCfg.isFullScreen ? '是' : '否',
            rate: `${percentage(this.buryCfg.endInfo.duration || 0, this.buryCfg.endInfo.videoDuration || 0)}%`,
            autoPlay: this.hadEnded || this.isClickPlay ? '手动点击' : '自动播放',
            ...this.buryCfg.endInfo
          })
          this.buryCfg.bury90 = false
          this.buryCfg.buryEnded = true
          this.hadEnded = new Date().getTime()
          break
        case 'waiting':
          // 记录卡顿信息
          this.buryCfg.lastWaiting = new Date().getTime()
          break
        case 'playing':
          const playTime = new Date().getTime()
          this.buryCfg.lastWaiting &&
            playTime - this.buryCfg.lastWaiting >= 2000 &&
            this.$emit('onPlayBury', 'playProcess', {
              autoPlay: this.hadEnded || this.isClickPlay ? '手动点击' : '自动播放',
              stuckTime: this.buryCfg.lastWaiting ? playTime - this.buryCfg.lastWaiting : null,
              stage: 8,
              ...this.buryCfg.endInfo
            })
          this.buryCfg.lastWaiting = null
          break
        case 'error':
          // 经确认暂时不加
          // this.$emit('onPlayBury', 'errors', { autoPlay: this.hadEnded||this.isClickPlay ? '手动点击' : '自动播放', stage: 5 })
          break
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import 'xgplayer-style/skin/style/index.scss'
.xgplayer.xgplayer-cssfullscreen-active
  position: fixed !important
  left: 0 !important
  top: 0 !important
  width: 100% !important
  height: 100% !important
  z-index: 99999 !important
  padding-top: 0px !important
.xgplayer
  .xgplayer-skin-default
    .xgplayer-enter
      .xgplayer-enter-spinner
        div
          width: 1% !important
</style>
<style lang="sass">
// 强制修改第二行字幕大小
.text-track-deputy
  font-size: 100% !important
</style>
